module.exports = __webpack_public_path__ + "img/img20.dd881cc2.png";